import React from "react";
import "../styles/SignaturePad.css";

// Typed-name electronic signature widget, styled after new_form/sign_new.png
function SignaturePad({ label, name, value, onChange, error, required = true }) {
  const handleClear = () => onChange(name, "");

  return (
    <div className="sigpad-wrapper">
      <label className="sigpad-label">
        {label}
        {required && <span className="mandate">*</span>}
      </label>
      <div className={`sigpad-box ${error ? "sigpad-box-error" : ""}`}>
        <div className="sigpad-input-row">
          <input
            type="text"
            className="sigpad-input"
            name={name}
            placeholder="Type your name"
            maxLength="60"
            value={value}
            onChange={(e) => onChange(name, e.target.value)}
          />
          {value && (
            <span className="sigpad-clear" onClick={handleClear}>
              &times;
            </span>
          )}
        </div>
        <div className="sigpad-preview">
          {value && <span className="sigpad-script">{value}</span>}
        </div>
        <p className="sigpad-disclaimer">
          This signature will be the electronic representation of your
          signature for all purposes when you use them on these consents and
          will be just the same as signature with a pen.
        </p>
      </div>
      {error && <span className="form4-error">{error}</span>}
    </div>
  );
}

export default SignaturePad;
